import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24, color = "#72808F" } = props
  return (
    <svg
      width={width}
      height={height}
      {...props}
      color={color}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 3L3 9" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 3L9 9" stroke="#72808F" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default SvgComponent
